const Button = {
  borderRadius: 70,
  borderRadiusLG: 70,
  lineHeight: '120%',
};

export default Button;
